export default __webpack_public_path__ + "static/celestial1-1084f56bb5c66bea61aa342a0ee721fe.png";